import { type ProductInterface } from "@jti/fe-common";
import type { ApiMagentoPriceTier } from "@jti/magento-types";

export default function getPriceTiers(data: ProductInterface): ApiMagentoPriceTier[] {
  return data?.price_tiers || [];
}
